import type { SourceFile } from "../sidebar/sources-types";
import {
    DATA_BANK_VIEW_CASTE_SUMMARY,
    DATA_BANK_VIEW_CONSTITUENCY_MAP,
    DATA_BANK_VIEW_PAST_ELECTION,
    type DataBankViewType,
} from "../sidebar/add-source/dataBankViewTypes";

export function resolveDataBankViewType(file: SourceFile): DataBankViewType | undefined {
    if (file.data_bank_view_type) return file.data_bank_view_type;
    if (file.data_bank_election) return DATA_BANK_VIEW_PAST_ELECTION;
    return undefined;
}

export function isDataBankSourceReady(file: SourceFile): boolean {
    if (file.data_bank_fsd_id == null) return false;
    const viewType = resolveDataBankViewType(file);
    if (!viewType) return false;
    if (viewType === DATA_BANK_VIEW_PAST_ELECTION) return Boolean(file.data_bank_election);
    if (viewType === DATA_BANK_VIEW_CONSTITUENCY_MAP) return Boolean(file.data_bank_map_key);
    return viewType === DATA_BANK_VIEW_CASTE_SUMMARY;
}

export function dataBankHeaderSubtitle(viewType: DataBankViewType | undefined): string | null {
    switch (viewType) {
        case DATA_BANK_VIEW_PAST_ELECTION:
            return "Past election results";
        case DATA_BANK_VIEW_CASTE_SUMMARY:
            return "Caste summary";
        case DATA_BANK_VIEW_CONSTITUENCY_MAP:
            return "Constituency maps";
        default:
            return null;
    }
}

export function dataBankTreeSubtitle(file: SourceFile): string {
    const viewType = resolveDataBankViewType(file);
    if (viewType === DATA_BANK_VIEW_PAST_ELECTION && file.data_bank_election) {
        return file.data_bank_election;
    }
    if (viewType === DATA_BANK_VIEW_CONSTITUENCY_MAP && file.data_bank_map_key) {
        return file.data_bank_map_key;
    }
    if (viewType === DATA_BANK_VIEW_CASTE_SUMMARY) return "Overall caste summary";
    return file.data_bank_fst_key ?? "Data bank";
}
